import { Flex, Heading, Link, Text } from "@applyboard/crystal-ui"
import { NavBars } from "../../../components/NavBars"
import { StudentApplication } from "../../../components/Application/types"
import { ChevronLeftOutlineIcon } from "@applyboard/ui-icons"
import { CurrentProgramSummaryCard } from "../CurrentProgramSummaryCard"
import { format } from "date-fns"
import { ApplicationSteps, convertTimelessDateStrToLocalDate } from "../../../utils"
import { ProgramFilters } from "../ProgramFilters"
import { ProgramList } from "../ProgramList"
import { ApplicationState } from "../../../hooks"
import { CampusInformation, ProgramInformation, ProgramIntakeTerm } from "@applyboard/school-applications-types-lib"

type SelectProgramProps = Readonly<{
  application: StudentApplication | null
  isUpdatingApplication: boolean
  setTemporaryApplication: (application: StudentApplication) => void
  setCurrentStep: (step: ApplicationSteps) => void
  handleUpdateApplication: (programIntakeId: string) => void
  currentApplicationId: string
}>

export function SelectProgram(props: SelectProgramProps) {
  return (
    <NavBars largePage>
      <Flex gap={6} direction="column">
        <Text>
          <Link
            href={props.application ? `/applications/${props.currentApplicationId}` : '/'}
            leadIcon={ChevronLeftOutlineIcon}
            variant="standalone"
          >
            {props.application ? 'Back to current application' : 'Back to My Applications'}
          </Link>
        </Text>
        {props.application ? (
          <CurrentProgramSummaryCard
            applicationSummary={{
              programName: props.application.attributes?.programSelected?.program?.name ?? '',
              campusName: props.application?.attributes?.programSelected?.campus?.name ?? '',
              intakeTermDate: props.application?.attributes?.programSelected?.programIntakeTerm
                ?.startDate
                ? format(
                    convertTimelessDateStrToLocalDate(
                      props.application?.attributes?.programSelected?.programIntakeTerm?.startDate,
                    ),
                    'MMM yyyy',
                  )
                : '',
            }}
          />
        ) : null}
        <Heading level={1} variant="headlineL">
          Program Selection
        </Heading>

        <ProgramFilters />
        <ProgramList
          loading={props.isUpdatingApplication}
          onSubmit={intake => {
            if (!props.application) {
              props.setTemporaryApplication({
                attributes: {
                  applicationState: ApplicationState.DRAFT,
                  programSelected: {
                    priority: 0,
                    programIntakeId: intake?.id,
                    program: intake?.attributes?.program as ProgramInformation,
                    programIntakeTerm: {
                      id: intake?.attributes?.intakeTerm?.id,
                      name: intake?.attributes?.intakeTerm?.name,
                      startDate: intake?.attributes?.intakeTerm?.startsOn,
                    } as ProgramIntakeTerm,
                    campus: intake?.attributes?.campus as CampusInformation,
                  },
                  applicationFee: {
                    amount: intake?.attributes?.program?.applicationFee,
                  },
                },
              } as StudentApplication)

              props.setCurrentStep(ApplicationSteps.ALTERNATE_PROGRAM_SELECT)
            } else {
              props.handleUpdateApplication(intake.id)
            }
          }}
          currentApplication={props.application?.attributes}
        />
      </Flex>
    </NavBars>
  )
}
